/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const VOD_BROWSE_MS_CLEAR_DATA = 'VOD_BROWSE_MS_CLEAR_DATA';
export const VOD_BROWSE_MS_UPDATE_VERTICAL_ITEMS = 'VOD_BROWSE_MS_UPDATE_VERTICAL_ITEMS';
export const VOD_BROWSE_MS_UPDATE_HORIZONTAL_ITEMS = 'VOD_BROWSE_MS_UPDATE_HORIZONTAL_ITEMS';
export const VOD_BROWSE_MS_UPDATE_HORIZONTAL_POSITIONS =
    'VOD_BROWSE_MS_UPDATE_HORIZONTAL_POSITIONS';
export const VOD_BROWSE_MS_UPDATE_SHOULD_HIDE_ADULT_STATE =
    'VOD_BROWSE_MS_UPDATE_SHOULD_HIDE_ADULT_STATE';
